import * as actionTypes from 'src/old/actions';

const toasts = (state = [], action) => {
  switch (action.type) {
    case actionTypes.ADD_TOAST:
      return [...state, action.toast];

    case actionTypes.REMOVE_TOAST:
      return state.filter(toast => toast.id !== action.toastId);

    default:
      return state;
  }
};

export default toasts;
